<template>
<el-dialog :title="!dataForm.id ? '新增' : '修改'" width="60%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="small">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <el-descriptions-item label="关联结算ID" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="accountId" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.accountId" placeholder="关联结算ID"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="结算单号" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="zjsdh" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.zjsdh" placeholder="结算单号"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="物料凭证" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="belnr" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.belnr" placeholder="物料凭证"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="项目" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="buzei" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.buzei" placeholder="项目"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="物料编码" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="matnr" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.matnr" placeholder="物料编码"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="物料描述" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="txz01" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.txz01" placeholder="物料描述"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="采购组织" :label-style="getStyle()" :content-style="getStyle2()">
                    <!-- <el-form-item prop="ekorg" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.ekorg" placeholder="采购组织"></el-input>
                    </el-form-item> -->
                    <el-form-item prop="ekorg" style="margin-bottom: 0;">
                        <span v-if="viewFlag === 'view'">{{dataForm.ekorg}}</span>
                        <el-select v-else v-model="dataForm.ekorg" filterable placeholder="请选择采购组织">
                            <el-option v-for="item in purchaseOrgList" :key="item.purchaseOrgCode" :label="item.purchaseOrgName" :value="item.purchaseOrgCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <!-- <el-descriptions-item label="采购组织名称" :label-style="getStyle()" :content-style="getStyle2()" >
                    <el-form-item prop="ekotx" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.ekotx" placeholder="采购组织名称"></el-input>
                    </el-form-item>
                </el-descriptions-item> -->
                <el-descriptions-item label="采购组" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="ekgrp" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.ekgrp" placeholder="采购组"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="采购组名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="eknam" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.eknam" placeholder="采购组名称"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="单位" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="meins" style="margin-bottom: 0;">
                        <span v-if="viewFlag === 'view'">{{dataForm.meins}}</span>
                        <el-select v-else v-model="dataForm.meins" filterable placeholder="请选择">
                            <el-option v-for="item in unitList" :key="item.code" :label="item.name" :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="数量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="zmenge" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.zmenge" placeholder="数量"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="开票数量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="zkpsl" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.zkpsl" placeholder="开票数量"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="库存地点" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="lgort" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.lgort" placeholder="库存地点"></el-input> -->
                        <span>{{dataForm.lgort}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="库存地点名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="lgobe" style="margin-bottom: 0;">
                        <span v-if="viewFlag === 'view'">{{dataForm.lgobe}}</span>
                        <el-select v-else v-model="dataForm.lgobe" filterable placeholder="请选择" @change="handleChange">
                            <el-option v-for="item in storePositionTypeList" :key="item.storeAddress" :label="item.storeName" :value="item.storeAddress">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="价格" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="znetpr" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.znetpr" placeholder="价格"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="税码" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="mwskz" style="margin-bottom: 0;">
                        <!-- <el-input v-model="dataForm.mwskz" placeholder="税码"></el-input> -->

                        <span v-if="viewFlag === 'view'">{{dataForm.mwskz}}</span>
                        <el-select v-else v-model="dataForm.mwskz" filterable placeholder="请选择">
                            <el-option v-for="item in taxCodeList" :key="item.taxCode" :label="item.taxRate" :value="item.taxCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="金额" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="wrbtr" style="margin-bottom: 0;">
                        <el-input v-model="dataForm.wrbtr" placeholder="金额"></el-input>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="付款日期" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="payDate" style="margin-bottom: 0;">
                        <el-date-picker v-model="dataForm.payDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <el-row>
        <el-col style="text-align: right">
            <el-button size="small" @click="view.visible = false">
                <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
            </el-button>
            <el-button size="small" type="primary" @click="dataFormSubmit()">
                <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
            </el-button>
        </el-col>
    </el-row>
</el-dialog>
</template>

<script>
import {
    queryPartById,
    addPart,
    editPart,
} from "@/controller/settlement";
import {
    getFactoryList,
    getPurchaseOrgList,
    getUnitList,
    getStorePositionTypeList,
    getTaxCodeList
} from "@/controller/systemData"
export default {
    data() {
        return {
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            viewFlag: '',
            viewData: {},
            purchaseOrgList: [],
            unitList: [],
            storePositionTypeList: [],
            taxCodeList: [],
            factoryList: [],
            factoryName: '',
            dataForm: {
                id: 0,
                accountId: '',
                zjsdh: '',
                belnr: '',
                buzei: '',
                matnr: '',
                txz01: '',
                ekorg: '',
                ekotx: '',
                ekgrp: '',
                eknam: '',
                meins: '',
                zmenge: '',
                zkpsl: '',
                lgort: '',
                lgobe: '',
                znetpr: '',
                mwskz: '',
                wrbtr: '',
                payDate: ''

            },
            // 开始
            dataRule: {
                // name: [{
                //     required: true,
                //     message: "编码名称不能为空",
                //     trigger: "blur",
                // }, ],
                // type: [{
                //     required: true,
                //     message: "编码类型不能为空",
                //     trigger: "blur",
                // }, ],
            },
        };
    },
    methods: {
        // 初始化
        init(id, accountId) {
            // debugger;
            this.dataForm.id = id || 0;
            // this.dataForm.accountId = accountId;
            this.view.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id查零件
                    queryPartById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
                this.getDataList()
            });
        },
        
        getDataList() {
            //获取工厂数据
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            })
            //获取采购组织数据
            getPurchaseOrgList({
                purchaseOrgCode: "",
                purchaseOrgName: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.purchaseOrgList = data.body;
                }
            })
            //获取单位数据
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
            //获取库存地点数据
            getStorePositionTypeList({
                storeCode: "",
                storeAddress: "",
                storeName: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.storePositionTypeList = data.body;
                }
            });
            getTaxCodeList({
                taxCode: "",
                taxRate: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.taxCodeList = data.body;
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let accountPartParams = {
                        id: this.dataForm.id || undefined,
                        accountId: this.dataForm.accountId,
                        'zjsdh':this.dataForm.zjsdh,
                        'belnr':this.dataForm.belnr,
                        'buzei':this.dataForm.buzei,
                        'matnr':this.dataForm.matnr,
                        'txz01':this.dataForm.txz01,
                        'ekorg':this.dataForm.ekorg,
                        'ekotx':this.dataForm.ekotx,
                        'ekgrp':this.dataForm.ekgrp,
                        'eknam':this.dataForm.eknam,
                        'meins':this.dataForm.meins,
                        'zmenge':this.dataForm.zmenge,
                        'zkpsl':this.dataForm.zkpsl,
                        'lgort':this.dataForm.lgort,
                        'lgobe':this.dataForm.lgobe,
                        'znetpr':this.dataForm.znetpr,
                        'mwskz':this.dataForm.mwskz,
                        'wrbtr':this.dataForm.wrbtr,
                        'payDate':this.dataForm.payDate
                    };
                    if (this.dataForm.id) {
                        // 更新零件
                        editPart(accountPartParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshAccountPartDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    } else {
                        // 创建零件
                        addPart(accountPartParams)
                            .then((data) => {
                                if (data && data.code === "00") {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                        duration: 1500,
                                        onClose: () => {
                                            this.view.visible = false;
                                            this.$emit(
                                                "refreshAccountPartDataList"
                                            );
                                        },
                                    });
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                }
            });
        },
        handleChange(val) {
            const type = this.storePositionTypeList.find(type => type.storeAddress === val)
            this.dataForm.lgort = type ? type.storeAddress : ''
            // this.factoryName = this.getFactoryName(this.dataForm.lgort)
        },
        // getFactoryName(val) {
        //     const factory = this.factoryList.find(factory => factory.factoryCode === val)
        //     return factory ? factory.factoryDesc : ''
        // },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            return 'width: 435.5px;'
        },
    },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .code-type-dialog-form {
        width: 100%;
    }
}
</style>
